import httpClient from "../../api/httpClient";
import SolicitacaoMaterial from "../classes/SolicitacaoMaterial";

interface HttpCalls {
  method: string;
  rota: string;
}

const calls: HttpCalls[] = [
  { method: "GET", rota: "Solicitacao/MateriaPrima/All/" },
  { method: "GET", rota: "Solicitacao/MateriaPrima/One" },
  { method: "POST", rota: "Solicitacao/MateriaPrima/Adicionar" },
  { method: "PUT", rota: "Solicitacao/MateriaPrima/Atualizar" },
  { method: "POST", rota: "Solicitacao/MateriaPrima/Atualizar/Colecao" },
  { method: "DELETE", rota: "Solicitacao/MateriaPrima/Apagar" },
  { method: "GET", rota: "Solicitacao/MateriaPrima/All/RecuperarPorFiltro" },
  { method: "DELETE", rota: "Solicitacao/MateriaPrima/ApagarLote" },
];

const cacheKey: string = "SolicitacaoMaterialCache";
const cacheKeySelC: string = "SolicitacaoMaterialCacheSelecionado";

const apiServico: String = "PLANEJAMENTO"

class SolicitacaoMaterialDataset extends httpClient {

  constructor() {
    super(String(apiServico));
  }

  async Adicionar(value: SolicitacaoMaterial): Promise<SolicitacaoMaterial> {
    const result = await super.post(calls[2].rota, value);
    return result;
  }

  async RecuperarPorFiltros(filters: any, codigoFornecedorSap: number): Promise<SolicitacaoMaterial[]> {
    const {
      solicitadaEm,
      para,
      codigoSku,
      quantidadeSolicitado,
    } = filters;

    const baseURL = calls[6].rota;
    const query = `?CodigoFornecedorSap=${codigoFornecedorSap}&NumeroContrato=0${codigoSku && `&CodigoSku=${codigoSku}`}${solicitadaEm != null ? `&SolicitadoEm=${solicitadaEm}` : ''}${para != null ? `&Para=${para}` : ''}${quantidadeSolicitado && `&QuantidadeSolicitado=${quantidadeSolicitado}`}`

    try {
      return super.Get(`${baseURL}${query}`).then(response => response.data);
    } catch (erro) {
      console.log(erro);
      return [];
    }
  }

  async Atualizar(value: SolicitacaoMaterial) {
    const result = await super.put(calls[3].rota, value);
    return result;
  }

  async AtualizarColecao(value: SolicitacaoMaterial[]) {
    const result = await super.post(calls[4].rota, value);
    return result;
  }

  async Apagar(value: SolicitacaoMaterial) {
    const result = await super.delete(calls[5].rota, value);
    return result;
  }

  async ApagarLote(idsSelecionados: number[]) {
    const result = await super.delete(calls[7].rota, idsSelecionados);
    return result;
  }

  async ListarAtivos(_codigoFornecedorSap: Number): Promise<SolicitacaoMaterial[]> {
    return await super.Get(calls[0].rota + _codigoFornecedorSap)
      .then((response) => {
        return JSON.parse(JSON.stringify(response.data));
      })
      .catch((erro) => {
        console.error(erro)
      });
  }

  getKeyCach(): string {
    return cacheKey;
  }

  getKeyCachClass(): string {
    return cacheKeySelC;
  }

  ListarFromCache(): SolicitacaoMaterial[] {
    let result: SolicitacaoMaterial[] = JSON.parse(cacheKey);
    return result;
  }

  AdicionarListaAoCache(value: SolicitacaoMaterial[]) {
    localStorage.setItem(cacheKey, JSON.stringify(value));
  }

  LimparListaDoCache() {
    localStorage.removeItem(cacheKey);
  }

  LimparObjetoDoCache() {
    localStorage.removeItem(cacheKeySelC);
  }

}
export default SolicitacaoMaterialDataset;

